export default __webpack_public_path__ + "static/media/check-white.fb593ed1.svg";